import * as v from 'valibot';
import Ajax from '../util/ajax';
import { zigbeeDeviceInfoUpdated } from '../features/zigbee_device_info/zigbeeDeviceInfoSlice';
import { zigbeeDeviceInfoSchema } from '../types/ZigbeeDeviceInfo';
export function fetchZigbeeDeviceInfo(zigbee_node_id) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch);
        const url = '/zigbee/' + zigbee_node_id + '/all';
        ajax.get(url, undefined, data => {
            const res = v.safeParse(zigbeeDeviceInfoSchema, data);
            if (res.success) {
                const device_info = res.output;
                dispatch(zigbeeDeviceInfoUpdated({ id: zigbee_node_id, device_info }));
            }
            else {
                console.error(v.summarize(res.issues));
            }
        });
    };
}
